import React, { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
// import { fetchVendorName } from '../Services/getVendorName'; // Ensure the correct path

const Division = [
  {
    id: 1,
    value: "Neiman Marcus Stores",
    label: "Neiman Marcus Stores",
  },
  {
    id: 3,
    value: "Neiman Marcus Direct",
    label: "Neiman Marcus Direct",
  },
  { id: 2, value: "Bergdorf Goodman", label: "Bergdorf Goodman" },
  { id: 4, value: "Last Call", label: "Last Call" },
];

export const PreTicketColumns = (handleEdit) => {

  const getDivisionLabel = (chain, area) => {
    console.log('getDivisionLabel', chain, area);
    if (chain == 1) {
      if (area == 12) {
        return Division.find(div => div.id == 1)?.label || 'N/A';
      }
      if (area == 13) {
        return Division.find(div => div.id == 3)?.label || 'N/A';
      }
    }
    return Division.find(div => div.id == chain)?.label || 'N/A';
  };

  
  
  return [
    {
      field: 'po_number',
      headerName: 'PO Number',
      width: 200,
      sortable: true,
    },
    {
      field: 'vendor_name',
      headerName: 'Vendor',
      width: 250,
    },
    {
      field: 'cancel_date',
      headerName: 'Cancel Date',
      width: 250,
      renderCell: (params) => (
        <span>
          {params.row.cancel_date ? new Date(params.row.cancel_date).toLocaleDateString() : ''}
        </span>
      )
    },
    {
      field: 'fedex_number',
      headerName: 'FedEx Number',
      width: 250
    },
    {
      field: 'freight',
      headerName: 'Freight($)',
      width: 250
    },
    {
      field: 'ticket_cost',
      headerName: 'Ticket Cost($)',
      width: 250
    },
    {
      field: 'chain',
      headerName: 'Division',
      width: 250,
      renderCell: (params) => (
        // <span>
        //   {params.row.area}
        // </span>
        <span>
          {getDivisionLabel(params.row.chain, params.row.area)}
        </span>
      )
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 140,
      renderCell: (params) => (
        <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
          <ModeEditIcon className='ml-5 edit-color' />
        </IconButton>
      )
    }
  ];
};
